/** @format */

import React from "react";
type titleProps = {
  title: String;
  titleClass: String;
};

const Title = ({ title, titleClass }: titleProps) => {
  return (
    <div className="relative flex justify-center items-center text-center">
      <h2 className={`hidden md:flex ${titleClass}`}>{title}</h2>
      <h2 className="md:absolute relative font-bold text-[28px] leading-[38px] tracking-[-0.02em]">
        {title}
      </h2>
    </div>
  );
};

export default Title;
